<template>
  <div id="app-loader">
    <div class="loader">
      <svg version="1.2" baseProfile="tiny" id="Layer_1" x="0px" y="0px" width="471.197px" height="471.197px" viewBox="0 0 471.197 471.197" overflow="inherit" preserveAspectRatio="xMidYMid meet">
        <g id="loader" />
        <circle id="circle-loader-primary" class="circle" fill="transparent" stroke="#8EC63E" stroke-width="40" stroke-linecap="round" stroke-miterlimit="10" cx="235.582" cy="235.114" r="212.599"/>
      </svg>
    </div>

    <div class="loader-text">
      <p v-if="loaderType === enums.LoaderEnum.APPLICATION_LOADING">
        Retrieving Application
      </p>

      <p v-if="loaderType === enums.LoaderEnum.SAVING">
        Saving Application
      </p>

      <p v-if="loaderType === enums.LoaderEnum.FAMILY_SAVING">
        Applications are being saved. This may take a few seconds. Do not close your browser.
      </p>

      <p v-if="loaderType === enums.LoaderEnum.WAIT_FOR_REDIRECTION">
        You Are Being Redirected
      </p>

      <p v-if="loaderType === enums.LoaderEnum.QR_CODE_GENERATING">
        QR Code Generation in Progress
      </p>
    </div>

    <div class="loader-wrapper">
      <p v-if="loaderType === enums.LoaderEnum.SMS_ARRIVED">
        Application Form Signature in Progress
      </p>

      <p v-if="loaderType === enums.LoaderEnum.WAIT_FOR_SMS">
        
    Tap the Link in the SMS to Start the Process of Electronic Signature of the Application.
    <br> <br>
    You didn't receive an SMS? Click the “Confirm Phone Number” button.
  
      </p>

      <Button
        v-if="loaderType === enums.LoaderEnum.WAIT_FOR_SMS"
        class="btn-primary"
        style="max-width: 400px"
        :iconRight="require('@/assets/svg/refresh-icon.svg')"
        @click="$emit('repeat-sms')"
      >
        <p class="m-0 pr-5">Confirm Phone Number</p>
      </Button>
    </div>
  </div>
</template>

<script>
import enums from '@/mixins/enums';
import Button from '@/components/Button/Button.vue';

export default {
  name: 'Loader',
  mixins: [enums],
  props: {
    loaderType: { required: false, type: Object, default: () => null },
  },
  components: {
    Button,
  },
};
</script>
